{
  "version": 1,
  "asset_id": "27710a69-b695-4c47-9e9a-7142874e2b23",
  "project_id": "ede4779f-2e7a-461a-91d6-654024119c69",
  "url": "/__l5e/assets-v1/27710a69-b695-4c47-9e9a-7142874e2b23/sylwia-warsztat-karteczki.jpg",
  "r2_key": "a/v1/ede4779f-2e7a-461a-91d6-654024119c69/27710a69-b695-4c47-9e9a-7142874e2b23/sylwia-warsztat-karteczki.jpg",
  "original_filename": "sylwia-warsztat-karteczki.jpg",
  "size": 159033,
  "content_type": "image/jpeg",
  "created_at": "2026-08-27T07:48:16Z"
}
